import React, { useState, useEffect } from "react";
import axios from "axios";
import './../components/switch-checkbox.js';
import { ApiBaseUrl } from '../constants/global';

const Freeship = () => {
    /*const apiBaseUrl = "https://oz-config.thinkingbigbusiness.com.au";*/
    /*Initialize state using useState hook*/
    const [formData, setFormData] = useState({
        id: '',
        amount: '',
        path: '',
        zone: ''
    });
    const fetchInfo = () => {
        var pathval = document.getElementById('freeship-path').value;
        var postdata = {"path": pathval};
        const responce = axios
          .post(`${ApiBaseUrl}/getshipdata`, postdata)
          .then(response => {
                if (response.data.freeshippingdata.amount > 0) {
                    setFormData({
                        id: response.data.freeshippingdata.id,
                        amount: response.data.freeshippingdata.amount,
                        path: response.data.freeshippingdata.path,
                        zone: response.data.freeshippingdata.zone,
                    });
                }
            })
            .catch(error => {
                setFormData({id: '',amount: '', path: pathval,});
                console.log(error)
            });
        return responce;
    };
    const [formActiveData, setFormActiveData] = useState({
        id: '',
        amount: '',
        path: '',
        zone: ''
    });
    const fetchActiveInfo = () => {
        var pathval = document.getElementById('active-path').value;
        var postdata = {"path": pathval};
        const responce = axios
          .post(`${ApiBaseUrl}/getshipdata`, postdata)
          .then(response => {
            let amt = response.data.freeshippingdata.amount;
                //if (typeof amt === "undefined" && amt > 0) {
                    setFormActiveData({
                        id: response.data.freeshippingdata.id,
                        amount: amt,
                        path: response.data.freeshippingdata.path,
                        zone: response.data.freeshippingdata.zone,
                    });
                //}
            })
            .catch(error => {
                setFormActiveData({id: '',amount: '', path: pathval,});
                console.log(error)
            });
        return responce;
    };
    useEffect(() => {
        fetchInfo();
        fetchActiveInfo();
    }, []);
    // Handle form input changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        if (value && parseFloat(value) > 0 && value.match(/\s/) == null){
            document.getElementById("freeship-sbt-btn").style.display = "inline-flex";
        } else {
            document.getElementById("freeship-sbt-btn").style.display = "none";
        }
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleActChange = (event) => {
        const { name } = event.target;
        //const { name, value } = event.target;
        //if (event.target.checked){
            document.getElementById("active-sbt-btn").style.display = "inline-flex";
        //} else {
        //    document.getElementById("active-sbt-btn").style.display = "none";
        //}
        setFormActiveData({
            ...formActiveData,
            [name]: event.target.checked
        });
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        var url;
        var html;
        var msgContainer = document.getElementById('page-message-freeship');
        if (formData.id !== "") {
            url = `${ApiBaseUrl}/updatefreeship`;
            html = "<p>Free Shipping Data successfully updated.</p>";
        } else {
            url = `${ApiBaseUrl}/addfreeship`;
            html = "<p>Free Shipping Data successfully added.</p>";
        }

        axios
          .post(url, formData)
          .then((response) => {
            setFormData({
                id: response.data.freeshippingdata.id,
                amount: response.data.freeshippingdata.amount,
                path: response.data.freeshippingdata.path,
                zone: response.data.freeshippingdata.zone,
            });
            msgContainer.style.display = "block";
            msgContainer.innerHTML = html;
            msgContainer.classList.add("success");
            document.getElementById("freeship-sbt-btn").style.display = "none";
            setTimeout(function(){
                msgContainer.style.display = "none";
            },10000);
          })
          .catch((error) => {
            msgContainer.style.display = "block";
            msgContainer.innerHTML = error;
            msgContainer.classList.add("error");
            document.getElementById("freeship-sbt-btn").style.display = "none";
            setTimeout(function(){
                msgContainer.style.display = "none";
            },10000);
          });
    };
    const handleSubmitActive = (event) => {
        event.preventDefault();
        var url;
        var html;
        var msgContainer = document.getElementById('page-message-active-btn');
        var activeCheckbox = document.getElementById("active-checkbox-amount");
        //console.log(activeCheckbox.checked);
        if (!activeCheckbox.checked){
            let text = "Are you sure do you want to disable all configurations!";
            if (window.confirm(text) === true) {
                //document.getElementById("active-sbt-btn").style.display = "none";
            } else {
                setFormActiveData({
                    ...formActiveData,
                    amount: 1
                });
                document.getElementById("active-sbt-btn").style.display = "none";
                return false;
            }
        }
        if (formActiveData.id !== "") {
            url = `${ApiBaseUrl}/updateactivestat`;
            html = "<p>Configuration successfully updated.</p>";
        } else {
            url = `${ApiBaseUrl}/addactivestat`;
            html = "<p>Configuration successfully added.</p>";
        }
        axios
            .post(url, formActiveData)
            .then((response) => {
                setFormActiveData({
                    id: response.data.freeshippingdata.id,
                    amount: response.data.freeshippingdata.amount,
                    path: response.data.freeshippingdata.path,
                });
                msgContainer.style.display = "block";
                msgContainer.innerHTML = html;
                msgContainer.classList.add("success");
                document.getElementById("active-sbt-btn").style.display = "none";
                setTimeout(function(){
                    msgContainer.style.display = "none";
                },10000);
            })
            .catch((error) => {
                msgContainer.style.display = "block";
                msgContainer.innerHTML = error;
                msgContainer.classList.add("error");
                document.getElementById("active-sbt-btn").style.display = "none";
                setTimeout(function(){
                    msgContainer.style.display = "none";
                },10000);
            });
    };
    return (
        <div>
            <div className="config-main">
                <div id="page-message-active-btn" className="page-message"></div>
                <form onSubmit={handleSubmitActive}>
                    <div>
                        <input
                            type="hidden"
                            name="id"
                            placeholder="id"
                            defaultValue={formActiveData.id}
                        />
                        <input
                            type="hidden"
                            name="path"
                            placeholder="path"
                            id="active-path"
                            defaultValue="active"
                        />
                    </div>
                    <div className="field checkbox-container">
                        <label htmlFor="active-checkbox-amount">Enable all configurations</label>
                        <input
                            type="checkbox"
                            id="active-checkbox-amount"
                            name="amount"
                            checked={parseInt(formActiveData.amount) === 1 ? true : false}
                            onChange={handleActChange}
                            max="1"
                        />
                        {/*<label className="checkbox-switch">
                            <span className="label">Shipping Configuration</span>
                            <input
                                type="checkbox"
                                role="switch"
                                id="setting-switch"
                                name="amount"
                                defaultValue={formData.amount}
                                onChange={handleChange}
                                checked={formData.amount ? true : false} />
                            <span className="state">
                                <span className="container">
                                    <span className="position"> </span>
                                </span>
                                <span className="on" aria-hidden="true">On</span>
                                <span className="off" aria-hidden="true">Off</span>
                            </span>
                        </label>*/}
                    </div>
                    <div className="active-btn-content">
                        <button id="active-sbt-btn" style={{display:"none"}}>Save</button>
                    </div>
                </form>
            </div>
            <div className="config-main">
                <h2>Free Shipping Configuration</h2>
                <div>
                    <div id="page-message-freeship" className="page-message"></div>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <input
                                type="hidden"
                                name="id"
                                placeholder="id"
                                defaultValue={formData.id}
                            />
                            <input
                                type="hidden"
                                name="path"
                                placeholder="path"
                                id="freeship-path"
                                defaultValue="freeship"
                            />
                        </div>
                        <div className="field">
                            <label htmlFor="freeship-amount">Enter Minimum Order Amount For Free Shipping</label>
                            <input
                                type="number"
                                id="freeship-amount"
                                name="amount"
                                placeholder="Enter Free Shipping Amount"
                                defaultValue={formData.amount}
                                onChange={handleChange}
                            />
                        </div>
                        {/*<div className="field">
                            <label htmlFor="freeship-zone-range">Enter Free Shipping Zone Range<br /><small>Add zones separated by commas (,) and<br />ranges separated by dashe (-);<br />spaces are not allowed.</small></label>
                            <textarea
                                id="freeship-zone-range"
                                name="zone"
                                placeholder="Enter Free Shipping Zone Range"
                                defaultValue={formData.zone}
                                onChange={handleChange}
                            ></textarea>
                        </div>*/}
                        <div>
                            <button id="freeship-sbt-btn" style={{display:"none"}}>Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
 
export default Freeship;